import { z, zCalendarDate, zDecimalRequired } from '@harvestiq/zod';

import {
  RmaInsurancePlanCodes,
  RmaLrpCommodityCodes,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { AgWorksEndorsementProcessingStatuses } from './constants';

export const createAgWorksLrpEndorsementRequestBodySchema = z.object({
  CoverageOID: z.string(),
  CommodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  InsurancePlanCode: z.nativeEnum(RmaInsurancePlanCodes),
  EffectiveDate: zCalendarDate(),
  AgentOfRecordOID: z.string(),
  PracticeCode: z.string(),
  TypeCode: z.nativeEnum(RmaLrpTypeCodes),
  TargetWeight: zDecimalRequired(),
  NumberOfHead: z.number().int().min(1).max(12000),
  EndorsementLength: z.number().int().positive(),
  CoverageLevel: zDecimalRequired(),
  InsuredShare: zDecimalRequired(),
  LotID: z.string().optional(),
  Remarks: z.string().optional(),
});

export type CreateAgWorksLrpEndorsementRequestBody = z.infer<
  typeof createAgWorksLrpEndorsementRequestBodySchema
>;

export const createAgWorksLrpEndorsementResponseSchema = z.object({
  policyNumber: z.string().nullable(),
  reinsuranceYear: z.number().nullable(),
  coverageOID: z.number(),
  premiumLineOID: z.number(),
  endorsementNumber: z.number(),
  effectiveDate: z.string().datetime(),
  agentOfRecordOID: z.number(),
  typeCode: z.nativeEnum(RmaLrpTypeCodes).nullable(),
  practiceCode: z.string().nullable(),
  targetWeight: z.number(),
  numberOfHead: z.number(),
  lotID: z.string().nullable(),
  insuredShare: z.number(),
  endorsementLength: z.number(),
  endDate: z.string().datetime(),
  coveragePrice: z.number(),
  coverageLevel: z.number(),
  rate: z.number(),
  liability: z.number(),
  totalPremium: z.number(),
  producerPremium: z.number(),
  processingStatus: z
    .nativeEnum(AgWorksEndorsementProcessingStatuses)
    .nullable(),
  requestTimestamp: z.string().datetime(),
  responseTimestamp: z.string().datetime(),
  message: z.string(),
  errors: z.array(z.string()),
  isValid: z.boolean(),
});
export type CreateAgWorksLrpEndorsementResponse = z.infer<
  typeof createAgWorksLrpEndorsementResponseSchema
>;
